import React from 'react';
const LayoutContext = React.createContext({
    open: true,
    name: 'Guest',
    onOpenHandle: () => {},
    onLogout: () => {}
});

export default LayoutContext;